import { ENDPOINTS } from "../config/endpoints";

export const competitionSchema = {
  steps: [
    {
      title: "Competition Details",
      fields: [
        {
          name: "name",
          type: "text",
          displayName: "Competition Name",
        },
        {
          name: "tournament",
          type: "select",
          displayName: "Tournament",
          fetch: ENDPOINTS.competitions.myTournaments,
        },
        {
          name: "season",
          type: "text",
          displayName: "Season",
        },
        {
          name: "start_date",
          type: "text",
          inputType: "date",
          displayName: "Start Date",
        },
        {
          name: "end_date",
          type: "text",
          inputType: "date",
          displayName: "End Date",
        },
        {
          name: "established_year",
          type: "text",
          inputType: "number",
          displayName: "Established Year",
        },
        {
          name: "end_year",
          type: "text",
          inputType: "number",
          displayName: "End Year",
        },
      ],
    },
  ],
};
